import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import i18n from "i18n/i18n";
import { logout } from "actions";
import { ReduxState } from "helpers/helper";
import {
  usePostClock,
  useDuration
} from "components/uis/navbar/quickbar/QuickbarUser";
import MainScreen from "./MainScreen";
import SRMSyncLoader from "./SRMSyncLoader";

const Logout = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const isLoggedIn = useSelector<ReduxState, boolean[]>(
    state => state.auth.isAuthenticated
  );
  const user = useSelector(state => state.auth.user);
  const postClock = usePostClock();
  const dispatch = useDispatch();
  const { duration } = useDuration();

  useEffect(() => {
    if (!isLoggedIn && query.get("callbackUrl")) {
      window.location.href = query.get("callbackUrl");
      return;
    }
    logoutUser();
  }, []);

  const logoutUser = async () => {
    if (duration === null) {
      await dispatch(logout());
    } else {
      await postClock().finally(async () => {
        await dispatch(logout());
      });
    }
    if (user?.is_tis && user?.company_sso_enabled === true) return;
    window.location.href = query.get("callbackUrl") || window.location.origin;
  };

  return (
    <MainScreen>
      <SRMSyncLoader message={i18n.t("logging_out")} />
    </MainScreen>
  );
};

export default Logout;
